import { render, staticRenderFns } from "./report-dki-p.vue?vue&type=template&id=3d5ffc7a&scoped=true&"
import script from "./report-dki-p.vue?vue&type=script&lang=ts&"
export * from "./report-dki-p.vue?vue&type=script&lang=ts&"
import style0 from "./report-dki-p.vue?vue&type=style&index=0&id=3d5ffc7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ffc7a",
  null
  
)

export default component.exports